import React from 'react';
import './Introduction.css';
import { Footer , Header} from '../index';
import { Link } from 'react-router-dom';
import intro  from '../../asserts/images/intro2isimm.jpg';
import Counter from '../Container/Counter';
import student from '../../asserts/images/student.png';
import teacher from '../../asserts/images/teacher.png';
import graduation from '../../asserts/images/graduation.png';
function Introduction(props) {
  return (
    <>
    <div  style={{backgroundColor:'#FCFCFC'}}>
    <Header/>
     <div className='containerPRES'>
        <div className='bgPRES'>  </div>
        <div className="container-fluid text-white text-center" style={{ position: 'relative', marginTop: '-160px', marginBottom: '100px' }}>
          <h1 style={{fontFamily:'fantasy', fontSize:'50px'}}className="container-fluid text-white text-center " id='h1pres'>Présentation</h1>
          <p ><Link className='linkdep' to="/">Accueil</Link> <span>{'>'}</span><Link className='linkdep'
            to="/"> ISIMM </Link>  <span>{'>'}</span> <Link className='linkdep'
            to="/">Introduction</Link> </p></div>
      </div>
    <div  style={{backgroundColor:'#FCFCFC'}}>
     <div className="containerINTRO">
      <h6 className='INTROH6' >  ISIMM , Institut d'Informatique et de Mathématique</h6>
      <h1>Bienvenue pour découvrir L’ISIMM  </h1>

          <div className="container1" >
                      <div className="content-box">
                        <p >
                          L’institut supérieur d'Informatique et de Mathématique de Monastir, plus communément appelée ISIMM,
                          fondée en 2002
                          Cette plateforme vous permet de découvrir les différentes formations assurées par l’ISIMM,
                          la vie-estudiantine, associative...
                          Nos étudiants participent bien au battement du cœur de notre établissement
                          au rythme de la vie associative.
                          La majorité des étudiants adhère à un club ou plus sur
                          des sujets très divers mais plutôt trop liés aux formations assurées par l’ISIMM.   <br/>
                          <br/> <br/> <br/>
                          <Link to="/visitevirtuelle">
                          <input type='button' className='BTN' value='Visite Virtuelle' onClick={()=>{console.log('hello world !')}}/> 

                          </Link>
                          
                          
                      
                        </p>
                      </div>

                      <div className="content-box">
                            <p>
                    
                              Ceci est une très bonne occasion pour ouvrir des perspectives devant nos étudiants 
                              pour faire preuve d’initiatives dans le domaine qui leur est cher!
                              A travers cette plateforme, les enseignants et les étudiants ainsi que le staff administratif
                              peuvent accéder à leurs comptes personnels à distance afin de faciliter la communication entre eux.
                              Visiter le site officiel de l’ISIMM par le public ou/et par les utilisateurs
                              vous permet de vivre en temps réel au siège de l’établissement.
                              <br/> <br/> 
                              <br/> <br/> <br/> <br/>


                            </p>
                        </div>
          </div>
    </div>
    </div>
    <div  style={{backgroundColor:'#FCFCFC'}}>
      <div className="containerINTRO" >
      <h1 style={{paddingTop:'30px'}}>Pourquoi choisir L’ISIMM ?  </h1>
          <div className="container1" >
                      <div className="content-box" style={{}}>
                        <p >
                        L’ISIMM se prévaut de la bonne réputation de ses diplômés. 
                        Le score d’orientation à cet établissement est en hausse 
                        d’une année à l’autre grâce à la détermination des enseignants et
                         à la qualité de ses programmes qui offrent un dosage judicieux de 
                         connaissances théoriques et pratiques.  <br/><br/>
                         Il y a en totalité trois départements pédagogiques :<br/><br/>
                           <Link to="/departementInfo" style={{textDecoration: 'none',color:'#162533'}}><span style={{fontWeight:'bold',paddingLeft:'40px'}}>Département Informatique  
                            <br/> </span></Link>
                            <Link  to="/departementM"style={{textDecoration: 'none',color:'#162533'}}><span style={{fontWeight:'bold',paddingLeft:'40px'}}>Département Mathématiques
                            <br/></span></Link>
                            <Link to="/departementT"style={{textDecoration: 'none',color:'#162533'}}><span style={{fontWeight:'bold',paddingLeft:'40px'}}>Département De Technologie </span><br/><br/> </Link>

                           Et enfin sans oublier sa vue panoramique apaisante sur la mer,
                            qui procure une énergie positive pour bien débuter chaque journée.
                     
                                                
                        </p>
                      </div>

                      <div className="content-box">
                            <p style={{ width: '120%', height: 'auto'  }}>
                            <img src={intro} alt="intro" style={{ width: '650px', height: '500px' ,marginTop:'-80px',maxWidth: '100%',marginLeft:'-40px'}} />
                            </p>
                        </div>
          </div>
    </div>
    </div>
        <div  className="containerINTRO" style={{ minHeight: '80vh', paddingTop: '5px',marginBottom:'70px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-evenly'}}>
                        <div style={{ paddingTop: '20px' }}>
                            <h4 id='titrecompteur'>Depuis 2002 jusqu’à maintenant, découvrez</h4>
                            <h1 className="container-fluid text-center">L'ISIMM EN CHIFFRE </h1>
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-evenly', paddingLeft: '100px',paddingRight: '100px',paddingTop:'10px' ,flexWrap:'wrap',flexDirection:'row',columnGap: '10px',rowGap: '10px'}}>
                        <div><Counter title="ETUDIANT" initialValue={0} stopValue={500} imageSrc={student} /></div>
                        <div><Counter title="ENSEIGNANT" initialValue={0} stopValue={100} imageSrc={teacher} /></div>
                        <div><Counter title="DIPLOME" initialValue={0} stopValue={400} imageSrc={graduation} /></div>
                    </div>
                  </div>    
    <Footer/>
    </div>
    </>
  )
}

export default Introduction